import React, { useEffect, useState } from "react";
import LightbulbIcon from "@mui/icons-material/Lightbulb";

const Illuminance1Widget = ({ widget, onValueUpdate }) => {
  const [illuminance, setIlluminance] = useState(0);
  const [isFlashing, setIsFlashing] = useState(false);

  useEffect(() => {
    if (widget?.items?.$w1) {
      const value = Number(widget.items.$w1.value);
      setIlluminance(isNaN(value) ? 0 : value);
      setIsFlashing(true);
      setTimeout(() => setIsFlashing(false), 500);
    }
  }, [widget]);

  return (
    <div
      className="flex items-center justify-center gap-2 w-full border rounded-2xl transition-colors duration-500"
      style={{
        height: "40px",
        borderColor: isFlashing ? "hsl(var(--primary))" : "hsl(var(--border))",
      }}
    >
      <LightbulbIcon
        style={{
          fontSize: "1.2rem",
          color: "#FFD54F",
        }}
      />
      <span className="text-[0.925rem] font-medium whitespace-nowrap overflow-hidden text-ellipsis max-w-full">
        {illuminance.toFixed(0)} lux
      </span>
    </div>
  );
};

export default Illuminance1Widget;
